import * as React from "react";
import { useTranslation } from "react-i18next";
import { COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT } from "theme/constants";
import ThemeEditorColor from "./ThemeEditorColor";
const ThemeEditorRow = ({ colorType, colorKey, colorName, currentThemeColors, onChange }) => {
  const { t } = useTranslation("enterprise_customization");
  const light = currentThemeColors == null ? void 0 : currentThemeColors[COLOR_SCHEME_LIGHT][colorType][colorKey];
  const dark = currentThemeColors == null ? void 0 : currentThemeColors[COLOR_SCHEME_DARK][colorType][colorKey];
  const handleChangeLight = (hex) => {
    onChange({ mode: COLOR_SCHEME_LIGHT, key: colorKey, type: colorType, hex });
  };
  const handleChangeDark = (hex) => {
    onChange({ mode: COLOR_SCHEME_DARK, key: colorKey, type: colorType, hex });
  };
  return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", null, colorName), /* @__PURE__ */ React.createElement(
    ThemeEditorColor,
    {
      color: light,
      onChange: handleChangeLight,
      label: t("theme_editor.edit_light_color", { colorName })
    }
  ), /* @__PURE__ */ React.createElement(
    ThemeEditorColor,
    {
      color: dark,
      onChange: handleChangeDark,
      label: t("theme_editor.edit_dark_color", { colorName })
    }
  ), /* @__PURE__ */ React.createElement("span", null));
};
export default ThemeEditorRow;
